import { Component } from 'react';
import type { ReactNode, ErrorInfo } from 'react';
import * as Sentry from '@sentry/browser';

interface Props {
  children: ReactNode;
  render: () => ReactNode;
}

interface State {
  crashed: boolean;
}

// Keeping this a class since there is no hook for componentDidCatch yet
// https://reactjs.org/docs/hooks-faq.html#do-hooks-cover-all-use-cases-for-classes
class ErrorBoundary extends Component<Props, State> {
  state: State = {
    crashed: false
  };

  static displayName = 'ErrorBoundary';

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ crashed: true });

    Sentry.withScope(scope => {
      scope.setExtras(errorInfo as Record<string, any>);
      Sentry.captureException(error);
    });
  }

  render() {
    const { render, children } = this.props;
    const { crashed } = this.state;

    if (crashed) {
      return render();
    }
    return children;
  }
}

export default ErrorBoundary;
